import serviceTermsKo from "lang/terms/serviceTerms.ko";
import serviceTermsEn from "lang/terms/serviceTerms.en";
import privacyCollectKo from "lang/terms/privacyCollect.ko";
import privacyCollectEn from "lang/terms/privacyCollect.en";
import privacyConsentKo from "lang/terms/privacyConsent.ko";
import privacyConsentEn from "lang/terms/privacyConsent.en";

/**
 * 파일명: index.js
 * 설명: 약관 전문 문서 저장소. 문서 종류 + 언어로 전문을 조회한다.
 *
 * 문서 종류
 *  - "collect" : 개인정보 수집 및 이용 동의문 — 회원가입 시 "동의를 받는" 문서
 *  - "privacy" : 개인정보처리방침 — 개인정보 보호법 제30조에 따라 "공개하는" 문서 (동의 대상 아님)
 *  - "service" : 서비스 이용 약관 — 회원가입 시 "동의를 받는" 문서
 *
 * 회원가입 체크박스에는 "collect" 와 "service" 만 연결한다.
 * "privacy" 는 체크박스 없는 링크로만 노출해야 한다.
 */
const DOCUMENTS = {
  collect: { ko: privacyCollectKo, en: privacyCollectEn },
  privacy: { ko: privacyConsentKo, en: privacyConsentEn },
  service: { ko: serviceTermsKo, en: serviceTermsEn },
};

/**
 * i18n 언어코드("ko", "en", "en-US" 등)를 문서 언어키로 정규화
 */
function resolveLang(language) {
  return String(language || "ko")
    .toLowerCase()
    .startsWith("en")
    ? "en"
    : "ko";
}

export function getTermsDocument(type, language) {
  const byLang = DOCUMENTS[type];

  if (byLang === undefined) {
    return null;
  }

  return byLang[resolveLang(language)] || byLang.ko || null;
}

export default DOCUMENTS;
